var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('TopNav',{on:{"company-change":_vm.refreshHome}}),_c('div',{staticClass:"main-wrapper"},[_c('router-view',{key:_vm.routerViewKey})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }